import { CalendarPrimeReact, DropdownPrimeReact } from "@finanedi.es/storybook"
import { TIPO_REMESA_CONST } from "common/components/IbanInputHandler/constants"
import { InputText } from "primereact/inputtext"
import {
  Control,
  Controller,
  FieldErrors,
  UseFormRegister,
  useWatch,
} from "react-hook-form"
import { useTranslation } from "react-i18next"
import { CuentaBancariaFormValues } from "../../UseCuentaBancariasForm"

interface MandateSelectorProps {
  register: UseFormRegister<CuentaBancariaFormValues>
  control: Control<CuentaBancariaFormValues>
  errors?: FieldErrors<CuentaBancariaFormValues>
}

export const MandateSelector = ({
  register,
  control,
  errors,
}: MandateSelectorProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const mandatoValues = useWatch({
    control,
    name: ["mandato.referencia", "mandato.fecha", "mandato.tipoRemesa"],
  })

  const hasAnyValue = mandatoValues.some(
    (value) => value !== undefined && value !== null && value !== ""
  )

  return (
    <section className='tw-flex tw-flex-col tw-gap-4'>
      <span className='tw-text-base tw-font-medium'>
        {t("contactos.cuentasBancarias.titleRemesa")}
      </span>
      <div className='tw-w-full tw-flex tw-flex-col tw-gap-2'>
        <span className='tw-text-sm'>
          {t("contactos.cuentasBancarias.refMandatoLabel")}
        </span>
        <span>
          <InputText
            className={`tw-w-full tw-text-sm tw-h-10 ${
              errors?.mandato?.referencia ? "!tw-border-danger" : ""
            }`}
            {...register("mandato.referencia", {
              required: !!hasAnyValue,
            })}
          />
        </span>
      </div>
      <div className='tw-w-full tw-grid tw-grid-cols-2 tw-gap-4'>
        <div className='tw-w-full tw-flex tw-flex-col tw-gap-2'>
          <span className='tw-text-sm'>
            {t("contactos.cuentasBancarias.dateMandatoLabel")}
          </span>

          <Controller
            control={control}
            name='mandato.fecha'
            rules={{ required: !!hasAnyValue }}
            render={({ field }) => (
              <CalendarPrimeReact
                id='fecha'
                clearButtonClassName='!tw-hidden'
                onChange={field.onChange}
                value={field.value}
                locale={language}
                placeholder='dd/mm/aaaa'
                dateFormat='dd/mm/yy'
                className='tw-w-full !tw-h-10 !tw-text-sm'
                inputClassName={`${
                  errors?.mandato?.fecha ? "!tw-border-danger" : ""
                }`}
                baseZIndex={2302}
                showIcon
              />
            )}
          />
        </div>
        <div className='tw-w-full tw-flex tw-flex-col tw-gap-2'>
          <span className='tw-text-sm'>
            {t("contactos.cuentasBancarias.typeLabel")}
          </span>
          <Controller
            control={control}
            name='mandato.tipoRemesa'
            rules={{ required: !!hasAnyValue }}
            render={({ field }) => (
              <DropdownPrimeReact
                options={TIPO_REMESA_CONST}
                optionLabel='name'
                optionValue='code'
                value={field.value}
                onChange={field.onChange}
                className={`[&>:nth-child(3)]:!tw-text-sm !tw-h-10 ${
                  errors?.mandato?.tipoRemesa ? "!tw-border-danger" : ""
                }`}
                panelClassName='!tw-text-sm'
                placeholder={`${t("contactos.cuentasBancarias.selectType")}`}
              />
            )}
          />
        </div>
      </div>
    </section>
  )
}
